import React from 'react';
import { Checkbox } from '../ui/checkbox';
import { NAV_ITEMS } from '../Layout';
import { VIEW_ONLY_ROLES } from '../../lib/moduleAccess';

export const ModuleAccessPicker = ({ value, onChange, role }) => {
  const editLocked = VIEW_ONLY_ROLES.includes(role);
  const access = value || {};
  const set = (href, lvl) => {
    const next = { ...access };
    if (lvl) next[href] = lvl; else delete next[href];
    onChange(next);
  };
  const setAll = (lvl) => {
    const next = {};
    if (lvl) NAV_ITEMS.forEach((n) => { next[n.href] = lvl; });
    onChange(next);
  };
  const viewCount = NAV_ITEMS.filter((n) => access[n.href]).length;
  const editCount = NAV_ITEMS.filter((n) => access[n.href] === 'edit').length;

  return (
    <div className="border rounded-lg" data-testid="module-access-picker">
      <div className="flex items-center justify-between px-3 py-2 bg-gray-50 border-b text-xs">
        <span className="text-gray-600" data-testid="module-access-summary">{viewCount} visible · {editCount} editable</span>
        <div className="flex gap-3">
          <button type="button" className="text-blue-600 hover:underline" onClick={() => setAll('view')} data-testid="access-all-view">All view</button>
          {!editLocked && <button type="button" className="text-blue-600 hover:underline" onClick={() => setAll('edit')} data-testid="access-all-edit">All edit</button>}
          <button type="button" className="text-gray-500 hover:underline" onClick={() => setAll(null)} data-testid="access-clear">Clear</button>
        </div>
      </div>
      <div className="grid grid-cols-[1fr_56px_56px] px-3 py-1.5 text-[11px] font-semibold uppercase text-gray-500 border-b">
        <span>Module</span><span className="text-center">View</span><span className="text-center">Edit</span>
      </div>
      <div className="max-h-64 overflow-y-auto divide-y">
        {NAV_ITEMS.map((n) => {
          const key = n.href.replace(/\//g, '');
          const lvl = access[n.href];
          return (
            <div key={n.href} className="grid grid-cols-[1fr_56px_56px] items-center px-3 py-1.5 text-sm hover:bg-gray-50">
              <span className="flex items-center gap-2"><n.icon className="h-3.5 w-3.5 text-gray-400" />{n.name}</span>
              <span className="flex justify-center">
                <Checkbox checked={!!lvl} onCheckedChange={(c) => set(n.href, c ? (lvl || 'view') : null)} data-testid={`access-view-${key}`} />
              </span>
              <span className="flex justify-center">
                <Checkbox checked={lvl === 'edit'} disabled={editLocked} onCheckedChange={(c) => set(n.href, c ? 'edit' : 'view')} data-testid={`access-edit-${key}`} />
              </span>
            </div>
          );
        })}
      </div>
      {editLocked && <p className="px-3 py-2 text-xs text-amber-600 border-t">Viewer roles are read-only. Pick HR Manager / Payroll Manager / Admin to allow Edit.</p>}
    </div>
  );
};
